"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateOfBirthMismatchWarningPopupWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var React = require("react");
var DateOfBirthMismatchWarningPopupWidget = /** @class */ (function (_super) {
    __extends(DateOfBirthMismatchWarningPopupWidget, _super);
    function DateOfBirthMismatchWarningPopupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    DateOfBirthMismatchWarningPopupWidget.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggle });
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: true, toggle: this.toggle },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block mr-3 mb-1", src: "/img/alert-grey-blue.svg" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium h6 banner banner-info" }, "Heads up! The date of birth on your driving licence does not match the date of birth we hold on file for you?"))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                    React.createElement("p", null,
                        React.createElement("strong", null, "Please check that your details are correct and try again."))),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-blue-dashboard", onClick: this.toggle }, "Try again"),
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-blue-dashboard", onClick: function () { window.location.href = "/dashboard/yourCarCovers"; } }, "Exit")))));
    };
    DateOfBirthMismatchWarningPopupWidget.prototype.toggle = function () {
        this.props.onStateChange(this.props.question.interactionField, null);
    };
    return DateOfBirthMismatchWarningPopupWidget;
}(plugin_journey_1.WidgetBase));
exports.DateOfBirthMismatchWarningPopupWidget = DateOfBirthMismatchWarningPopupWidget;
//# sourceMappingURL=DateOfBirthMismatchWarningPopupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/DateOfBirthMismatchWarningPopupWidget.js
// module id = 3154
// module chunks = 0